import fp from 'lodash/fp';
import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import actions from './actions';

const dropdownState = (filterName, selectedValues = []) => ({
  [filterName]: {
    isOpen: false,
    selectedValues
  }
});

export const initialState = {
  filters: {
    ...dropdownState('continent'),
    ...dropdownState('country'),
    ...dropdownState('state'),
    ...dropdownState('city'),
    ...dropdownState('show', ['Upcoming'])
  }
};

const reducers = {
  [actions.events.filters.setIsOpen]: ({ filters }, { payload: { filter, isOpen } }) => ({
    filters: {
      ...filters,
      [filter]: {
        ...fp.get(filter, filters),
        isOpen
      }
    }
  }),
  [actions.events.filters.setSelectedValues]: ({ filters }, { payload: { filter, selectedValues } }) => ({
    filters: {
      ...filters,
      [filter]: {
        ...fp.get(filter, filters),
        selectedValues
      }
    }
  }),
  [LOCATION_CHANGE]: (state, action) => initialState
};

export default handleActions(reducers, initialState);



// WEBPACK FOOTER //
// ./src/state/modules/events/reducers.js